import { useState } from "react"

export default function ExampleAboutPage({data, theme}) {
  const [isHoverMail, setIsHoverMail] = useState(false);
  return (
    <div className='exampleAboutPage' style={{backgroundColor:`${theme.secondary_color}`}}>
      <h3 className="exampleAboutPage_header" style={{textShadow:`2px 2px 4px ${theme.primary_color}`, color:`${theme.accent_color}`}}>שירות לקוחות - {data.website_name}</h3>
      <div className="exampleAboutPage_content" style={{borderBottom:`0.5px dashed ${theme.accent_color}`}}>
        <h4 style={{color:theme.accent_color}}>מוקד התמיכה - {data.phone}</h4>
        <div className="exampleAboutPage_email">
          <h4 style={{color:theme.accent_color}}>אימייל - {data.email}</h4>
          <div className="exampleAboutPage_email_img" onMouseEnter={()=>{setIsHoverMail(true)}} onMouseLeave={()=>{setIsHoverMail(false)}} style={{color:isHoverMail ? theme.primary_color : theme.accent_color}}>✉</div>
        </div>
        <h4 style={{color:theme.accent_color}}>כתובת העסק - {data.address}</h4>
      </div>
    </div>
  )
}
